// extracted by mini-css-extract-plugin
export default {"wrapper":"mobile-header_wrapper__lbGYF","container":"mobile-header_container__amdA-"};